RouterListener.$inject = [
    '_',
    '$rootScope',
    '$location',
    '$state',
    'Analytics',
    'Club',
    'CONST',
];

function RouterListener(
    _,
    $rootScope,
    $location,
    $state,
    Analytics,
    Club,
    CONST,
) {
    /**
     * Redirige `app.bookings` -> `app.grid` cuando el club tiene activada la
     * nueva grilla de reservas (feature flag `disable_bookings_calendar`).
     *
     * Por que esto vive en el listener y no en el resolve de `app`:
     * usamos @uirouter/angularjs 0.3.2 (version vieja). Dentro de un resolve
     * no hay forma de saber el state destino, pero el evento
     * $stateChangeStart si recibe `toState` y `toParams`. Por eso la decision
     * se toma aca.
     *
     * Por que es necesario esperar a que CONST este cargado:
     * al refrescar (o entrar por bookmark) en /app/bookings, el listener se
     * dispara antes de que firstLoad('app') termine de cargar CONST/Club.
     * En ese momento Club.hasNewBookingsCalendarEnabled() retorna `true` por
     * defecto (el check interno es `Club[featureKey] !== true` y con
     * `undefined` se cumple), por lo que redirigia mal a /app/grid incluso
     * en clubes que no tienen la feature activa.
     */
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
        if (toState.name !== 'app.bookings') return;

        if (CONST._loaded) {
            if (Club.hasNewBookingsCalendarEnabled()) {
                event.preventDefault();
                $state.go('app.grid', { date: toParams.date || undefined });
            }
            return;
        }

        // preventDefault aborta la transicion actual -> el resolve firstLoad('app')
        // no se llega a ejecutar. El $state.go() de abajo inicia una transicion
        // nueva; para entonces CONST._loaded ya es true y el resolve hace early
        // return sin volver a llamar a CONST.$info(). Asi evitamos doble request.
        event.preventDefault();
        CONST.$info().then(function () {
            if (Club.hasNewBookingsCalendarEnabled()) {
                $state.go('app.grid', { date: toParams.date || undefined });
            } else {
                $state.go('app.bookings', toParams);
            }
        });
    });

    var trackPage = _.debounce(function (event) {
        Analytics.trackPage($location.path());
    }, 500);

    $rootScope.$on('$stateChangeSuccess', trackPage);
}

export default RouterListener;
